import { AppealsCounterController } from './appeals.counter.controller';

export const appealsCounter: angular.IDirectiveFactory = () => ({
  restrict: 'A',
  bindToController: true,
  controller: AppealsCounterController,
  controllerAs: 'vm',
  template: /** HTML */ `
  <span
    class="appeals-counter"
    ng-class="{'is-new': vm.hasNewAppeals, 'is-multi-letter': vm.count > 9}"
    ng-if="vm.count > 0"
  >
    {{ vm.count > 99 ? '99+' : vm.count }}
  </span>`,
  scope: {
    forceCount: '@?',
    forceHasNew: '@?',
  },
});
